export const STOREY_SETTINGS_NUMBER_INPUT_WIDTH = '120px';
